<template>
  <div>
    <a-spin :spinning="isLoading">
      <div class="seach-doc">
        <div v-show="docList.length > 0" @click="todoc(item)" class="seach-doc-ul" v-for="(item, index) in docList" :key="index">
            <div class="seach-doc-title">{{item.title}}</div>
            <div class="seach-doc-answer">{{ contentSummary(item.content) }}</div>
            <div v-if="item.interfaceMethod" class="interface-method">{{ $t('helper_layout_interface_name') }}：{{ item.interfaceMethod }}</div>
        </div>
        <div v-show="docList.length === 0" class="SeachDoc_no_list">
          <img width="306" height="228" src="@/assets/no_list.png" alt="list" />
          <div>{{$t('helper_layout_query_none')}}</div>
        </div>
      </div>
    </a-spin>
    <div style="text-align:center;margin-bottom: 20px;" v-show="searchObj.total > 10">
        <a-pagination v-model="current" :total="searchObj.total" @change="onChange" show-less-items />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { docQueryList } from '@/api/login'
import { openNotificationWithIcon } from '@/utils/util'
import { toPlainText } from '@/utils/markdown'
import { mapState } from 'vuex'

export default {
  name: 'SeachDoc',
  data () {
    return {
      current: 1,
      isLoading: false
    }
  },
  components: {
    // VDistpicker
  },
  computed: {
    ...mapState({
      'docList': state => state.isLogin.docList,
      'searchObj': state => state.isLogin.searchObj,
      'menus': state => state.isLogin.menus
    })
  },
  mounted () {
    if (this.searchObj.pageNum) {
      this.current = this.searchObj.pageNum
    } else {
      this.onChange(1)
    }
  },
  methods: {
    /** 搜索摘要：富文本/Markdown 统一转纯文本，单行展示 */
    contentSummary (content) {
      return toPlainText(content)
    },
    onChange (current) {
      this.current = current
      this.isLoading = true
      let data = {
        content: this.searchObj.serachValue || this.searchObj.content,
        pageNum: current,
        pageSize: 10
      }
      docQueryList(data).then((res) => {
        if (res.code === '200') {
          let searchobj = {
            total: res.total,
            content: this.searchObj.serachValue || this.searchObj.content,
            pageNum: res.pageNum,
            list: res.dataList
          }
          this.$store.commit('SERACHDOC', searchobj)
        } else {
          openNotificationWithIcon(res.message)
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    todoc (item) {
      // // this.$store.commit('MATCH', item)
      // console.log(this.menus)
      // console.log('ggg', this.findMenuParentId(this.menus, item.catalogId))
      this.$router.push({
        path: '/documentCenter',
        query: {
          docId: item.documentId + '',
          catId: item.level === 2 ? `0-${item.catalogId}-${item.catalogId},0-${this.findMenuParentId(this.menus, item.catalogId)}` : `0-${item.catalogId}`
        }
      })
    },
    findMenuParentId (list, catalogId, parentId) {
      console.log(catalogId, parentId)
      for (let item of list) {
        if (`${item.catalogId}` === `${catalogId}`) {
          // console.log('parentId', item.parentId)
          return item.parentId
        }
        if (item.childCatalog instanceof Array) {
          return this.findMenuParentId(item.childCatalog, catalogId)
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.seach-doc {
    text-align: center;
    background-color: #fff;
    min-height: 604px;
    width: 1200px;
    margin: 0 auto;
    margin-top: 25px;
    padding-left: 24px;
    margin-bottom: 32px;
    .callme-title {
        padding-top: 76px;
        margin-bottom: 32px;
        font-weight:600;
        color:#333333;
        font-size:24px;
    }
    .describe {
       width:485px;
       margin: 0 auto;
       font-size:14px;
       margin-top: 32px;
       text-align: left;
       margin-bottom: 20px;
    }
}

.seach-doc-title {
  font-size:14px;
  font-weight:600;
  color: #4978D6;
}
.seach-doc-answer {
  margin-top: 5px;
  font-size:12px;
  width: 1200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 18px;
}
.SeachDoc_no_list {
  text-align: center;
  margin-top: 203px;
  color: #999999;
  font-size:24px;
  font-family:PingFangSC-Semibold,PingFang SC;
  font-weight:600;
}
.seach-doc-ul {
  position: relative;
  cursor: pointer;
  text-align: left;
  padding: 14px 0 16px;
  border-bottom:1px solid #eee;
}
.seccess-box {
  padding-top: 134px;
}
.interface-method {
  position: absolute;
  right: 0;
  top: 20px;
}
</style>
